import { jsx as a, Fragment as $ } from "react/jsx-runtime";
import g from "html-react-parser";
import I, { useState as C, useEffect as M, useContext as P, useMemo as y } from "react";
const j = {
  mathJaxLoaded: !1
}, L = I.createContext(j), { Provider: O } = L, k = ({ children: t }) => {
  const [e, s] = C(!1);
  return M(() => {
    const r = {
      loader: {
        load: ["input/tex", "output/chtml"]
      },
      tex: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"]
        ]
      },
      chtml: {
        scale: 1,
        // keep consistent size
        matchFontHeight: !1,
        // disable auto font scaling
        font: "mathjax-fira"
        // Font support: https://github.com/mathjax/MathJax-src/releases/tag/4.0.0-alpha.1#fonts
      },
      startup: {
        ready: () => {
          window.MathJax.startup.defaultReady(), window.MathJax.startup.promise.then(() => {
            s(!0);
          });
        }
      }
    };
    window.MathJax ? s(!0) : (window.MathJax = r, _([
      "https://cdn.jsdelivr.net/npm/mathjax@4.0.0-beta.3/startup.js"
    ]));
  }, []), /* @__PURE__ */ a(O, { value: { mathJaxLoaded: e }, children: t });
}, _ = (t) => new Promise((e) => {
  const s = t.map(
    (r) => new Promise((f) => {
      const n = document.createElement("script");
      n.src = r, n.async = !0, n.onload = f, document.head.appendChild(n);
    })
  );
  Promise.all(s).then(e);
}), B = /\\\((.*?)\\\)|\\\[(.*?)\\\]|\$\$?(.*?)\$\$?/, p = /(\\\(.*?\\\))|(\\\[.*?\\\])|(\$\$?.*?\$\$?)/, N = /\\\[(.*?)\\\]|\$\$(.*?)\$\$/, S = /(\(\[\^([^\]]+)\]([^)]*)\))/, E = /(\(\[\^[^\]]+\][^)]*\))/, A = (t) => /* @__PURE__ */ a(D, { children: t });
let b = 0;
const m = () => `key${b++}`, D = ({ children: t }) => {
  const { mathJaxLoaded: e } = P(L), s = y(() => g(t, {
    replace: (n) => {
      const { type: v, data: d } = n;
      if (v !== "text") return n;
      const T = E.test(d), w = p.test(d);
      if (!T && !w) return n;
      const J = d.split(E).filter(Boolean).flatMap((i, h) => {
        const u = i.match(S);
        if (u) {
          const o = u[2], x = u[3];
          return o ? [
            x ? /* @__PURE__ */ a(
              "span",
              {
                className: "footnote-scope",
                onMouseEnter: (l) => {
                  l.preventDefault();
                  const c = document.getElementById(
                    `popover-${o}`
                  );
                  c && (c.style.display = "block", c.style.position = "");
                },
                onMouseLeave: (l) => {
                  l.preventDefault();
                  const c = document.getElementById(
                    `popover-${o}`
                  );
                  c && (c.style.display = "none");
                },
                role: "heading",
                "aria-level": 2,
                children: x
              },
              `fs-${m()}`
            ) : null,
            /* @__PURE__ */ a("sup", { children: /* @__PURE__ */ a(
              "a",
              {
                className: "footnote-ref",
                href: `#footnote-${o}`,
                onClick: (l) => {
                  l.preventDefault(), document.getElementById(`footnote-${o}`)?.scrollIntoView({ behavior: "smooth" });
                },
                children: o
              }
            ) }, `fn-${m()}`)
          ] : "";
        }
        return p.test(i) ? i.split(p).filter(Boolean).map((o) => N.test(o) ? /* @__PURE__ */ a(
          "span",
          {
            className: "mathjax-container",
            children: o
          },
          `lb-${h}-${m()}`
        ) : B.test(o) ? /* @__PURE__ */ a(
          "span",
          {
            className: "mathjax-inline-container",
            children: o
          },
          `li-${h}-${m()}`
        ) : o) : i;
      });
      return /* @__PURE__ */ a($, { children: J });
    }
  }), [t]), r = y(
    () => p.test(t),
    [t]
  );
  return M(() => {
    r && F(e);
  }, [e, r, t]), /* @__PURE__ */ a($, { children: s });
}, F = (t = !1) => {
  const e = window.MathJax;
  e && (t || e.typesetClear && e.typesetPromise) && (e.typesetClear(), e.typesetPromise());
};
export {
  k as M,
  D as T,
  L as m,
  A as p,
  F as r
};
//# sourceMappingURL=parse-CWxGbFYe.js.map
